import { Notification } from './notification.model';

export class ListNotification {
    data: Array<Notification> = [];
    page: number;
    maxSize: number;
    sort: string = '';
    propertiesSort: string = '';
    totalElement: number;

    constructor(data = null) {
        data = data || {};
        this.data = [];
        if (data.data && data.data instanceof Array) {
            data.data.forEach((item) => {
                this.data.push(new Notification(item));
            });
        }

        this.page = data.page;
        this.maxSize = data.maxSize;
        this.sort = data.sort || '';
        this.propertiesSort = data.propertiesSort || '';
        this.totalElement = data.totalElement;
    }
}